import { useFormField } from '@calendly/form';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useGetOrganizationQuery } from 'common';
import { useEventTypeContext } from 'features/event_type_provider';
import { getKindDescription, useETEditorFormikPoolingType } from 'services/event_types';
import { EditableEventType } from './editable_event_type';
import { Footer } from './footer';
import { Header } from './header';
import { LockedEventType } from './locked_event_type';
import { MoreDropdown } from './more_dropdown';
import { MoreDropdownParentMet } from './more_dropdown_parent_met';
import { StateTriggerProvider } from './state';
import { useDebouncedFormContext } from '../../hooks';
const containerCss = "c1g0npve";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const rowContainerCss = "r1jzkhqc";
const RowContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rowContainerCss, props.className)} />;
});
export const NameAndColorFields = ({
  isLocked,
  headerComponent,
  colorPickerComponent,
  moreDropdownComponent,
  footerComponent,
  isSingleUseLink = false,
  isSULCreation = false
}) => {
  const [{
    value: nameValue
  }, _, {
    setValue: setNameValue
  }] = useFormField({
    name: 'name'
  });
  const {
    errors: {
      name: debouncedNameError
    }
  } = useDebouncedFormContext();
  const {
    data: {
      pp_to_lp_migration_status_enabled: ppToLpMigrationStatusEnabled
    } = {}
  } = useGetOrganizationQuery();
  const {
    eventType,
    isCreation
  } = useEventTypeContext();
  const {
    isCollective,
    isRoundRobin,
    isCollectiveRoundRobin
  } = useETEditorFormikPoolingType();
  const {
    isUser,
    isShared,
    isMETChild,
    isMETParent,
    isAdhocEventType,
    public: isPublic,
    is_user_group_managed: isUserGroupManaged,
    isGroup,
    isSolo
  } = eventType;
  const hideSecretIconLpMigr = (isUser || isMETParent) && ppToLpMigrationStatusEnabled || isShared;
  const kindDescription = getKindDescription({
    isAdhocEventType,
    isCollective,
    isRoundRobin,
    isCollectiveRoundRobin,
    isGroup,
    isSolo
  });
  const HeaderComponent = headerComponent || Header;
  const MoreDropdownComponent = moreDropdownComponent || MoreDropdown;
  const FooterComponent = footerComponent || Footer;
  return <StateTriggerProvider>
      <Container>
        <HeaderComponent />
        <RowContainer>
          {isLocked ? <LockedEventType /> : <EditableEventType colorPickerComponent={colorPickerComponent} isSULCreation={isSULCreation} nameError={debouncedNameError} nameValue={nameValue} secret={!isPublic && !isSingleUseLink} setNameValue={setNameValue} />}
          {!isCreation && (isMETParent ? <MoreDropdownParentMet /> : <MoreDropdownComponent hideSecretToggleLpMigr={hideSecretIconLpMigr} isNameLocked={isLocked} />)}
        </RowContainer>
        <FooterComponent isAdhocEventType={isAdhocEventType} isMETChild={isMETChild} kindDescription={kindDescription} groupManaged={isUserGroupManaged} />
      </Container>
    </StateTriggerProvider>;
};

require("./name_and_color_fields.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./name_and_color_fields.js");